import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LatLng } from 'leaflet'
import { Childcare, ECCUser } from '../firebase/types-ecc'

interface IEccSlice {
    centreId?: string | null
    centre?: Childcare | null
    centreUser?: ECCUser | null
    adminCount?: number

    parkingLocation?: LatLng
}

export const initialState: IEccSlice = {
    adminCount: undefined,
    parkingLocation: undefined,
    centreId: undefined,
    centre: undefined,
    centreUser: undefined,
}

export const schoolSlice = createSlice({
    name: 'school',
    initialState,
    reducers: {
        setCentreDefault: () => {
            // state.adminCount = initialState.adminCount
            // state.parkingLocation = initialState.parkingLocation
            // state.centreId = initialState.centreId
            // state.centre = initialState.centre
            // state.centreUser = initialState.centreUser
            return initialState
        },
        setSelectedCentre: (
            state,
            action: PayloadAction<string | undefined | null>
        ) => {
            state.centreId = action.payload
        },
        setCentre: (state, action: PayloadAction<Childcare | null>) => {
            state.centre = action.payload
        },
        setCentreUser: (state, action: PayloadAction<ECCUser | null>) => {
            state.centreUser = action.payload
        },
        setParkingLocation: (
            state,
            action: PayloadAction<LatLng | undefined>
        ) => {
            state.parkingLocation = action.payload
        },
        setAdminCount: (state, action: PayloadAction<number>) => {
            state.adminCount = action.payload
        },
    },
})

export const {
    setCentreDefault,
    setSelectedCentre,
    setCentre,
    setCentreUser,
    setParkingLocation,
    setAdminCount,
} = schoolSlice.actions

export default schoolSlice.reducer
